import React from "react";
import { ButtonVariant, ButtonSize, ButtonStyle } from "./styles";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fill?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  noPadding?: boolean;
}

const Button = ({
  variant = "primary",
  size = "medium",
  fill,
  leftIcon,
  rightIcon,
  type = "button",
  children,
  ...rest
}: ButtonProps) => {
  return (
    <ButtonStyle
      {...rest}
      variant={variant}
      size={size}
      isFill={fill}
      type={type}
    >
      {leftIcon}
      {children}
      {rightIcon}
    </ButtonStyle>
  );
};

export default Button;
